<mat-action-list>
  <button
    mat-list-item
    *ngFor="let row of rows"
    (click)="onClickRow(row)"
    [ngClass]="{ isClicked: row.id === clickedRow?.id }"
  >
    <mat-icon matListIcon *ngIf="row.icon">{{ row.icon }}</mat-icon>
    <p matLine>{{ row.name }}</p>
  </button>
</mat-action-list>
